import Head from 'next/head';
import Script from 'next/script';

import * as snippet from '@segment/snippet';

import { staticPath } from '@libraries/common/staticPath';

type Property = string;
type Content = string;
type Opengraph = Record<Property, Content>;

type SteadioHeadProps = {
  title?: string;
  image?: string;
  opengraph?: Opengraph;
};

const defaultImage =
  'https://steadio-asset.s3.ap-northeast-2.amazonaws.com/static/images/steadio_thumbnail.png';

export default function SteadioHead({
  title,
  image = defaultImage,
  opengraph,
}: SteadioHeadProps) {
  const opengraphArray = Object.keys(opengraph!).map((property) => ({
    property,
    content: opengraph![property],
  }));

  return (
    <>
      <Head>
        <title>{title || '스테디오 Steadio'}</title>
        <meta name="twitter:site" content="steadio" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        <meta name="twitter:description" content={title} />
        <meta name="twitter:image" content={image} />
        {opengraphArray?.map(({ property, content }) => (
          <meta property={property} content={content} key={property} />
        ))}
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
        />
        <meta property="og:site_name" content="Steadio" key="og:site_name" />
      </Head>
      <Script
        id="segment-script"
        dangerouslySetInnerHTML={{
          __html: snippet.min({
            apiKey: process.env.NEXT_PUBLIC_SEGMENT_KEY,
            page: false,
          }),
        }}
      />
      <Script
        src="https://t1.kakaocdn.net/kakao_js_sdk/2.0.0/kakao.min.js"
        integrity="sha384-PFHeU/4gvSH8kpvhrigAPfZGBDPs372JceJq3jAXce11bVA6rMvGWzvP4fMQuBGL"
        crossOrigin="anonymous"
        onLoad={initKakaoSdk}
      />
    </>
  );
}

const defaultOpengraph = {
  'og:title': '스테디오 Steadio',
  'og:description': '꾸준한 수입, 창작의 새로운 동력',
  'og:image': `${staticPath('images/steadio_thumbnail.png')}`,
};

const initKakaoSdk = () => {
  if (!window.Kakao.isInitialized()) {
    window.Kakao.init(process.env.NEXT_PUBLIC_KAKAO_SDK!);
  }
};

SteadioHead.defaultProps = {
  opengraph: defaultOpengraph,
};
